import { render, staticRenderFns } from "./common-login.vue?vue&type=template&id=720a9e9e&scoped=true"
import script from "./common-login.vue?vue&type=script&lang=js"
export * from "./common-login.vue?vue&type=script&lang=js"
import style0 from "./common-login.vue?vue&type=style&index=0&id=720a9e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720a9e9e",
  null
  
)

export default component.exports